var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3132 1.75725C19.6562 4.10025 19.6562 7.89925 17.3132 10.2422L10.2432 17.3132C7.89925 19.6562 4.10025 19.6562 1.75725 17.3132C-0.58575 14.9702 -0.58575 11.1712 1.75725 8.82825L8.82725 1.75725C11.1712 -0.58575 14.9702 -0.58575 17.3132 1.75725ZM11.6572 13.0702L6.00025 7.41325L3.17125 10.2432C1.60925 11.8042 1.60925 14.3372 3.17125 15.8993C4.73325 17.4613 7.26625 17.4613 8.82825 15.8993L11.6572 13.0693V13.0702ZM15.8993 3.17125C14.3372 1.60925 11.8042 1.60925 10.2422 3.17125L7.41525 5.99925L13.0722 11.6562L15.9002 8.82825C17.4622 7.26625 17.4622 4.73325 15.9002 3.17125H15.8993Z",
    fill: "#15274B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrug);
export default __webpack_public_path__ + "static/media/drug.1ddd994be1c3868e4d4c54f89f5cc8f3.svg";
export { ForwardRef as ReactComponent };